import { referralModule } from '@/store/referral/module'
import { isPromise } from '@/store/utils'

const getValidReferral = () => {
    const validReferral = referralModule.state.validReferral.value

    if (isPromise(validReferral)) {
        return null
    } else {
        return validReferral
    }
}

const getReferralError = () => {
    return referralModule.state.referralError
}

const getDiscountAmount = () => {
    const referral = referralModule.state.validReferral.value

    if (!referral) {
        return null
    } else if ('name' in referral) {
        return referral.percent_off
            ? `${referral.percent_off}%`
            : `$${((referral.amount_off || 0) / 100).toFixed(2)}`
    } else {
        return '20%'
    }
}

const calculateDiscountedPrice = (baseCost: number) => {
    const referral = referralModule.state.validReferral.value

    if (!referral) {
        return baseCost
    } else if ('name' in referral) {
        const discount = referral.percent_off
            ? ((referral.percent_off / 100) * baseCost)
            : referral.amount_off || 0
        const discountedPrice = baseCost - discount
        return discountedPrice < 0 ? 0 : discountedPrice
    } else {
        return 0.8 * baseCost
    }
}

const getMetadataBannerMessage = () => {
    const referral = referralModule.state.validReferral.value

    if (
        referral
        && 'metadata' in referral
        && referral.metadata?.bannerMessage
    ) {
        return referral.metadata?.bannerMessage
    }

    return null
}

const getMetadataPreselectedPlan = () => {
    const referral = referralModule.state.validReferral.value

    if (
        referral
        && 'metadata' in referral
        && referral.metadata?.preselectedPlan
    ) {
        return referral.metadata?.preselectedPlan
    }

    return null
}

export default {
    getValidReferral,
    getReferralError,
    calculateDiscountedPrice,
    getDiscountAmount,
    getMetadataBannerMessage,
    getMetadataPreselectedPlan,
}
